module.exports = __webpack_public_path__ + "img/leg.be5030ca.webp";